var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64299 16.192C7.23365 16.0162 8.21388 15.6409 9.15849 14.9024C10.5418 13.8209 12.0993 11.7539 11.6748 8.04413C11.6534 7.68923 11.4334 4.57088 10.116 0.956328L9.94959 0.499878H2.05068L1.88431 0.956328C0.566835 4.57103 0.346721 7.68938 0.325507 8.04413C-0.0990364 11.7539 1.45848 13.8209 2.84178 14.9024C3.78639 15.6409 4.76675 16.0162 5.35728 16.192V22.4494L1.14502 23.0045L1.21715 24.4999H10.7758L10.8479 23.0047L6.64299 22.4504V16.192ZM3.55741 13.6564C1.98279 12.4253 1.32515 10.5965 1.60235 8.22038L1.60698 8.16593C1.60865 8.13668 1.77309 5.31578 2.90632 1.99988H9.09408C10.2272 5.31578 10.3916 8.13668 10.3932 8.16533L10.3979 8.22053C11.0143 13.5032 6.72721 14.6669 6.00142 14.825C5.68192 14.7533 4.58868 14.4626 3.55741 13.6564Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.d7c0d8248ff5bb79a965620106bd4f27.svg";
export { ForwardRef as ReactComponent };